import { auth } from 'db/config';
import { onAuthStateChanged } from 'firebase/auth';
import { usePathname, useRouter } from 'next/navigation';
import { useState, useEffect } from 'react';
import moment from 'moment';
import Routes from 'data/routes';

export const useAuthManager = () => {
  const [loading, setLoading] = useState(true);
  const [isLogged, setLogged] = useState(false);
  const [user, setUser] = useState(null);
  const pathname = usePathname();
  const router = useRouter();

  const loginPaths = [Routes.login, Routes.register];
  const isLoginPath = loginPaths.includes(pathname);

  useEffect(() => {
    setLogged(window.localStorage.getItem('logged'));

    const unsubscribeAuth = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      if (currentUser) {
        window.localStorage.setItem('logged', moment().valueOf());
        if (isLoginPath) router.push(Routes.home);
      } else window.localStorage.removeItem('logged');
    });

    // Se limpia la suscripción de autenticación
    return () => unsubscribeAuth();
  }, []);

  return {
    loading,
    isLogged,
    user,
  };
};
